<div
  #host
  class="codemirror-v2-host"
  [class.codemirror-v2-host--invalid]="formControl.dirty && formControl.invalid"
  [attr.data-id]="field.dataId"
></div>
